import parse from 'html-react-parser';

export const parseText = (text: string) => parse(text);
